import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
export function TireInstallationPage() {
  return <div data-id="element-1150">
      {/* Page Header */}
      <div className="bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1151">
        <p className="text-[#822433] font-bold text-sm uppercase tracking-widest mb-3" data-id="element-1152">
          Our Services
        </p>
        <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-1153">
          ⚙️ Tire Installation & Balancing
        </h1>
        <p className="text-gray-400 text-base mt-4 max-w-xl mx-auto" data-id="element-1154">
          Precision installation by certified technicians for a smooth, safe
          ride every time.
        </p>
      </div>

      {/* Main Content */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-1155">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-1156">
          <div data-id="element-1157">
            <h2 className="text-2xl sm:text-3xl font-black text-black mb-5" data-id="element-1158">
              Installed Right. Balanced Perfectly.
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5" data-id="element-1159">
              Improper tire installation can lead to dangerous vibrations,
              uneven wear, and even blowouts. At Ameritech Tires, our certified
              technicians use state-of-the-art mounting and balancing equipment
              to ensure every tire is installed to manufacturer specifications.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-1160">
              Tire balancing distributes weight evenly across the tire and wheel
              assembly, eliminating vibration and extending tire life. We
              balance every tire we install — no exceptions. Whether you bought
              tires from us or brought your own, we'll get the job done right.
            </p>
          </div>

          {/* What's Included */}
          <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-1161">
            <h3 className="font-black text-black text-xl mb-6" data-id="element-1162">
              What's Included
            </h3>
            <ul className="space-y-4" data-id="element-1163">
              <li className="flex items-start gap-3" data-id="element-1164">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1165" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1166">
                  Professional mounting on all vehicle types
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1167">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1168" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1169">
                  Computer-aided dynamic wheel balancing
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1170">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1171" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1172">
                  Valve stem replacement included
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1173">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1174" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1175">
                  Torque-to-spec lug nut tightening
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1176">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1177" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1178">
                  TPMS sensor check and reset
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1179">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1180" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1181">
                  Post-installation safety inspection
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full bg-[#F5F5F5] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1182">
        <div className="max-w-5xl mx-auto" data-id="element-1183">
          <h2 className="text-2xl sm:text-3xl font-black text-black mb-6 text-center" data-id="element-1184">
            Why Professional Installation Matters
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1185">
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1186">
              <div className="text-3xl mb-3" style={{
              background: '#CC0000'
            }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-1187">
                🔧
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1188">
                Precision Equipment
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1189">
                We use calibrated torque wrenches and computerized balancers —
                not guesswork.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1190">
              <div className="text-3xl mb-3" data-id="element-1191">🚗</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1192">
                Smooth Ride
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1193">
                Balanced tires eliminate steering wheel vibration and uneven
                wear patterns.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1194">
              <div className="text-3xl mb-3" data-id="element-1195">⏱️</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1196">
                Fast Turnaround
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1197">
                Most installations are completed within 45–60 minutes. Walk-ins
                welcome.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="w-full bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1198">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-1199">
          Ready to Get Started?
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-1200">
          Book your installation appointment today — same-day service available
          at all 3 locations.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1201">
          <Link to="/contact" className="inline-flex items-center justify-center bg-[#822433] hover:bg-[#6B1D29] text-white font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1202">
            Book an Appointment
          </Link>
          <Link to="/services" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1203">
            View All Services
          </Link>
        </div>
      </section>
    </div>;
}